import { useState, useEffect } from "react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const usePaidCourses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ✅ Arrow function for fetching
  const fetchCourses = async () => {
    try {
      setLoading(true);

      const res = await fetch(`${BASE_URL}/student/paid-courses/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });

      if (!res.ok) throw new Error("Failed to fetch courses");

      const data = await res.json();
      setCourses(data.courses || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // ✅ useEffect using arrow function
  useEffect(() => {
    fetchCourses();
  }, []);

  return { courses, loading, error, fetchCourses };
};

export default usePaidCourses;
